import {
  jb_info_page_hero_css_default
} from "./chunk.GDR3RJQD.js";
import {
  Spaceable
} from "./chunk.3FKBYJ4V.js";
import {
  reset_css_default
} from "./chunk.PBU2AIHD.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  D,
  ke,
  r
} from "./chunk.NBIYIO67.js";
import {
  n
} from "./chunk.QXWAL3TN.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-info-page-hero/jb-info-page-hero.ts
var JbInfoPageHero = class extends Spaceable(r) {
  _getContentSpacingProperties() {
    return { colsMdUp: 10, type: "no-vertical-space" };
  }
  render() {
    return ke`
      <div>
        <slot></slot>
        ${this.header ? ke`<h1>${this.header}</h1>` : D}
        ${this.subheader ? ke`<p>${this.subheader}</p>` : D}
      </div>
    `;
  }
};
JbInfoPageHero.styles = [reset_css_default, jb_info_page_hero_css_default];
__decorateClass([
  n()
], JbInfoPageHero.prototype, "header", 2);
__decorateClass([
  n()
], JbInfoPageHero.prototype, "subheader", 2);
JbInfoPageHero = __decorateClass([
  customElement("jb-info-page-hero")
], JbInfoPageHero);

export {
  JbInfoPageHero
};
